module.exports = __webpack_public_path__ + "img/bg-home.d717a567.png";